import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(
        Polygon,
        {
          points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2",
          stroke: `${color}`
        }
      )
    }
  );
};
Icon.displayName = "Zap";
const Zap = memo(themed(Icon));
export {
  Zap
};
//# sourceMappingURL=zap.js.map
